<template>
<div class="w-full md:pl-10 md:w-3/4">
    <h1 class="mt-2 mb-4 font-sans-bold">Admin Settings</h1>

    <div class="mb-4 group__checkbox">
        <div class="select-box">
            <label class="text-base font-normal" for="published">
                <input type="checkbox" id="published" v-model="form.published" class="mr-3">
                <span class="check inline-block mr-2"></span>
                <span class="flex-1">Published</span>
            </label>
        </div>
    </div>
    <div class="my-6">
        <button class="button mr-4" @click.stop.prevent="save" :class="{ 'opacity-50 cursor-not-allowed': saving }" :disabled="saving">
            <template v-if="saving">Processing...</template>
            <template v-else>Save</template>
        </button>
    </div>
</div>
</template>

<script>
    import { mapGetters } from "vuex";
    import messaging from "../../../mixins/messaging";

    export default {
        name: "ResourceCreateAdmin",
        mixins: [messaging],
        data: () => ({
            form: {
                published: false
            },
            saving: false,
            next: "resource-basics"
        }),
        computed: {
            ...mapGetters({
                resource: "resource"
            })
        },
        watch: {
            resource(resource) {
                if (!_.isEmpty(resource)) {
                    this.form.published = resource.published;

                    this.$nextTick(function() {
                        // this.$store.dispatch('setUnsavedData', false)
                    });
                }
            }
        },
        methods: {
            save() {
                this.saving = true;

                this.$validator.validateAll().then(result => {
                    if (!result) {
                        this.saving = false;
                        return;
                    }

                    this.$toasted.show("Resource currently saving...");

                    let route = this.$laroute.route("api.resources.update.admin", {
                        resource: this.resource.id
                    });

                    axios
                        .put(route, this.form)
                        .then(response => {
                            this.saving = false;
                        })
                        .catch(error => {
                            console.log(error);
                            this.displayError(error);
                        });
                });
            }
        },
        mounted() {
            const id = this.$route.params.id;
            this.$store.dispatch("getResource", { id: id });
        }
    };
</script>
